import { FormlyFieldConfig } from '@ngx-formly/core';

import { ISnChipsAutocompleteTemplateOptions } from './chips-autocomplete-template-options.interface';

export interface ISnChipsAutocompleteFormFieldConfig<M = any> extends FormlyFieldConfig {
  type: 'chips-autocomplete';
  templateOptions?: ISnChipsAutocompleteTemplateOptions<M>;
}
